import User from '@/models/User';
import { Model } from './Model';

export type KlassAssessment = Model & {
  behaviorAssessment: BehaviorAssessment;
  commentAssessment: CommentAssessment;
  author: User;
  klassId: number;
};

export type BehaviorAssessment = Model & {
  energy: BehaviorRatingEnum;
  maturity: BehaviorRatingEnum;
  speed: BehaviorRatingEnum;
  klassAssessmentId: number;
};

export type CommentAssessment = Model & {
  comment: string;
  klassAssessmentId: number;
};

export enum BehaviorRatingEnum {
  ONE = 1,
  TWO,
  THREE,
}

export enum KlassAssessmentTypeEnum {
  COMMENT = 'COMMENT',
  BEHAVIOR = 'BEHAVIOR',
}
